import React, { useEffect, useState } from 'react'
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TableCell,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import Pagination from '../../../components/hooks/BasePagination'
import { mdiPencil, mdiDelete, mdiEye, mdiEyeOutline } from '@mdi/js'
import Icon from '@mdi/react'
import colors from '../../../assets/colors'
import { dateFormated, exportFormatedMoney } from '../../../util/utils'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import DetailsModal from './DetailsModal'

const List = ({ form, setForm }) => {
  const data = useSelector(state => state.catalogacaoRelatory.data)
  const meta = useSelector(state => state.catalogacaoRelatory.meta)

  const [paginate, setPaginate] = useState({
    page: 1,
    rows: 10,
  })

  const [modalOpen, setModalOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const handleChangeRowsPerPage = e => {
    const { value } = e.target
    setPaginate({ ...paginate, rows: value })
  }

  const handleChangePage = (event, newPage) => {
    setPaginate({ ...paginate, page: newPage })
  }

  useEffect(() => {
    setForm({ ...form, ...paginate })
  }, [paginate])

  const handleEdit = id => {
    // TODO: Implementar edição
    console.log('Edit:', id)
  }

  const handleDelete = id => {
    // TODO: Implementar exclusão
    console.log('Delete:', id)
  }

  const handleViewDetails = item => {
    setSelectedItem(item)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setSelectedItem(null)
  }

  const getMeasureType = id => {
    const measuresTypes = {
      1: 'Unit',
      2: 'M²',
      3: 'M. Lin.',
      4: 'Kg.',
    }

    return measuresTypes[id] || 'N/A'
  }

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                style={{ borderBottom: 'none', padding: 0 }}
                colSpan={5}
              />

              <TableCell
                style={{
                  color: colors.primary,
                  borderColor: colors.primary,
                  padding: 0,
                }}
                colSpan={3}
                align="center"
              >
                Dados da catalogação
              </TableCell>
            </TableRow>

            <TableRow>
              <StyledTableCellHeader>Nº OS</StyledTableCellHeader>
              <StyledTableCellHeader>Descrição</StyledTableCellHeader>
              <StyledTableCellHeader align="center">Tipo</StyledTableCellHeader>
              <StyledTableCellHeader align="center">Qtde</StyledTableCellHeader>
              <StyledTableCellHeader align="center">
                Total
              </StyledTableCellHeader>
              <StyledTableCellHeader width={'180px'} align="center">
                Qtde
              </StyledTableCellHeader>
              <StyledTableCellHeader width={'180px'} align="center">
                Total
              </StyledTableCellHeader>
              <StyledTableCellHeader width={'180px'} align="center">
                Data
              </StyledTableCellHeader>
              <StyledTableCellHeader align="center">
                Detalhes
              </StyledTableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map(item => (
              <TableRow key={item.id} hover>
                <StyledTableCellBody
                  component={Link}
                  to={`attendance/${item?.service_id}/edit?value=1${location.search}`}
                >
                  {item?.service_id_laundry_client}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {item?.serviceItem?.serviceType?.name}
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  {getMeasureType(
                    item?.serviceItem?.serviceType?.measure_type_id
                  )}
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  {item?.quantity}
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  {exportFormatedMoney(item?.final_value)}
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  {item?.catalog_quantity}
                </StyledTableCellBody>{' '}
                <StyledTableCellBody align="center">
                  {exportFormatedMoney(item?.catalog_final_value)}
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  {item?.created_at}
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  <IconButton
                    onClick={() => handleViewDetails(item)}
                    title="Ver detalhes da catalogação"
                  >
                    <Icon path={mdiEyeOutline} size={1} />
                  </IconButton>
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        from={meta?.from}
        to={meta?.to}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={paginate?.rows}
        rows={meta?.total}
        page={paginate?.page}
        handleChangePage={handleChangePage}
      />

      <DetailsModal
        open={modalOpen}
        onClose={handleCloseModal}
        item={selectedItem}
      />
    </>
  )
}

export default List
